export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/invite-user-register' */ './InviteUserRegister'
  );
